import $axios from '../services/apiLms.js'

const state = () => ({
    chart_data: [],
})

const mutations = {
    ASSIGN_CHART_DATA(state, payload) {
        state.chart_data = payload
    },
}

const actions = {
    getChartDataTatib({ commit }, paramsData) {
        return new Promise((resolve) => {
            $axios.get(`operator/tatib/chart`, { params : paramsData })
                .then((response) => {
                    commit('ASSIGN_CHART_DATA', response.data.data)
                    resolve(response.data)
                })
        })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}